<template>
  <div>
    <app-heading :text="'Excluded Products'" :heading="'main'"></app-heading>
    <v-row class="mb-7">
      <v-col cols="12" sm="4" md="3" lg="2" class="pt-0 pb-0" v-if="showField">
        <v-text-field
          v-model="product"
          placeholder=" "
          label="Primary Access Technology"
          hide-details
          class="mt-3"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="8" md="9" lg="10" class="pt-0 pb-0">
        <v-btn
          class="primary"
          :disabled="text === 'Save' && this.product === ''"
          @click="showField ? excludeProduct() : switchLabel()"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
          >{{ text }}</v-btn
        >
      </v-col>
    </v-row>
    <ag-grid-vue
      :style="{ width, height }"
      domLayout="autoHeight"
      class="ag-theme-alpine mb-4"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="items"
      :frameworkComponents="frameworkComponents"
      :pagination="true"
      :paginationPageSize="10"
      @grid-ready="onFirstDataRendered"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
export default {
  name: "ExcludedProducts",
  components: {
    AgGridVue,
  },
  data: () => ({
    height: "100%",
    width: "100%",
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    items: [],
    frameworkComponents: null,
    product: "",
    showField: false,
  }),
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "ID",
        field: "id",
        sortable: true,
        maxWidth: 100,
        filter: true,
      },
      {
        headerName: "Primary Access Technology",
        field: "name",
        sortable: true,
        filter: true,
      },
    ];

    vm.defaultColDef = {
      autoHeight: true,
      resizable: true,
    };
  },
  mounted() {
    let vm = this;
    vm.loadExcludedProducts();
  },
  methods: {
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
    autoSizeAll(skipHeader) {
      var allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    excludeProduct() {
      let vm = this;
      vm.saveProduct(vm.product).then((data) => {
        vm.setHttpResponse({
          text: data.statusText,
          color: data.status === 200 ? "success" : "error",
        });

        vm.showField = false;
        vm.product = "";
        vm.loadExcludedProducts();
      });
    },
    switchLabel() {
      let vm = this;
      vm.showField = true;
    },
    loadExcludedProducts() {
      let vm = this;
      vm.getExcludedProducts().then((result) => {
        vm.items = result.data;
      });
    },
  },
  computed: {
    text() {
      let vm = this;
      if (vm.showField) return "Save";
      else return "Add Product";
    },
  },
};
</script>

<style lang="scss" scoped></style>
